import WOW from "wow.js";

export function initWow() {
    new WOW().init();
}
